module.exports = __webpack_public_path__ + "fonts/Montserrat_Bold_Latin.39d93cf6.woff2";